import { Link } from 'react-router-dom';

import { organizationPlansPath } from 'application/types/routes';
import { useAPI } from 'hooks/api/useAPI';
import { useCanDeployPipeline } from 'deployments/hooks/useCanDeployPipeline';
import { useCurrentOrganization } from 'hooks/api/useCurrentOrganization';

import { FormMessage } from 'components/FormMessage/FormMessage';

import Pipeline from 'types/pipeline';

export type DeploymentFormNodesNotIncludedInPlanWarningProps = {
  pipeline: Pipeline | undefined;
  onLink?: () => void;
};

export function DeploymentFormNodesNotIncludedInPlanWarning({
  pipeline,
  onLink,
}: DeploymentFormNodesNotIncludedInPlanWarningProps) {
  const { applicationID } = useAPI();
  const { data: organization } = useCurrentOrganization();

  const { canDeploy, nodeTypesNotIncluded } = useCanDeployPipeline(pipeline);

  if (!pipeline || canDeploy) {
    return null;
  }

  return (
    <FormMessage intent="danger" icon="warning">
      This workflow contains the following nodes not included in your plan:{' '}
      <strong>{nodeTypesNotIncluded.join(', ')} </strong>
      <br />
      Please{' '}
      <Link
        to={organizationPlansPath(applicationID, organization?.id)}
        className="link"
        onClick={() => onLink?.()}
      >
        switch or upgrade your plan
      </Link>{' '}
      to continue.
    </FormMessage>
  );
}
